import { useEffect, useRef, useCallback } from 'react';
export function useAutoScroll({ itemCount, isStreaming, enabled = true }) {
    const listRef = useRef(null);
    const scrollToBottom = useCallback(() => {
        if (listRef.current && itemCount > 0) {
            listRef.current.scrollToItem(itemCount - 1, 'end');
        }
    }, [itemCount]);
    useEffect(() => {
        if (enabled && (isStreaming || itemCount > 0)) {
            scrollToBottom();
        }
    }, [enabled, isStreaming, itemCount, scrollToBottom]);
    return { listRef, scrollToBottom };
}
